export default {
  months: [
    {
      name: "Styczeń",
      number: 1
    },
    {
      name: "Luty",
      number: 2
    },
    {
      name: "Marzec",
      number: 3
    },
    {
      name: "Kwiecień",
      number: 4
    },
    {
      name: "Maj",
      number: 5
    },
    {
      name: "Czerwiec",
      number: 6
    },
    {
      name: "Lipiec",
      number: 7
    },
    {
      name: "Sierpień",
      number: 8
    },
    {
      name: "Wrzesień",
      number: 9
    },
    {
      name: "Październik",
      number: 10
    },
    {
      name: "Listopad",
      number: 11
    },
    {
      name: "Grudzień",
      number: 12
    }
  ]
};
